import api from 'api'

type DeleteBillRateRequest = {
  billRateId: number
}

export const deleteBillRate = async (
  request: DeleteBillRateRequest
): Promise<void> => {
  await api.delete(`/admin/bill_rate/${request.billRateId}`)
}
